<template></template>

<script>
    export default {
        created() {
            window.location = '/';
        }
    }
</script>
